export const LeadTypeOptions = [
  { label: "DL_BD", value: "BD" },
  { label: "DL_LD", value: "LD" },
  { label: "CL_MEDIA", value: "CL" },
];
